<script lang="ts">
    import { Col, FormGroup, Input, Label, Row } from "sveltestrap";
    import data from "../../../../Data/Project/Project.json"
    import { Clientname, Priority, ProjectRate, ProjectTitle, ProjectType } from "../../../../utils/Constant/Constant";
</script>
<Row>
    <Col>
      <FormGroup>
        <Label>{ProjectTitle}</Label>
        <Input type="text" placeholder="Project name *" />
      </FormGroup>
    </Col>
</Row>
<Row>
    <Col>
        <FormGroup>
          <Label>{Clientname}</Label>
          <Input type="text" placeholder="Name client or company name" />
        </FormGroup>
    </Col>
</Row>
<Row>
    <Col sm="4"> 
        <FormGroup>
          <Label>{ProjectRate}</Label>
          <Input type="text" placeholder="Enter project Rate" />
        </FormGroup>
    </Col>
    <Col sm="4">
        <FormGroup>
            <Label>{ProjectType}</Label>
            <Input type="select" class="form-select" name="select" id="exampleSelect" value="Hourly">
            {#each data.projecttypedata as options}
                <option>{options.option}</option>
            {/each}
            </Input>
        </FormGroup>
    </Col>
    <Col sm="4">
        <FormGroup>
            <Label>{Priority}</Label>
            <Input type="select" class="form-select" name="select" id="exampleSelect" value="Low">
            {#each data.prioritydata as options }
                <option>{options.option}</option>
            {/each}
            </Input>
        </FormGroup>
    </Col>
</Row>